import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../../Navbar'
import Select from 'react-select';
import { ScaleLoader } from 'react-spinners';
import Workbook from 'react-excel-workbook'
import CsvParse from '@vtex/react-csv-parse';
import moment from 'moment';
import ReactGA from 'react-ga';
const { proxy } = require('../../../ip_api.config')

class Film_MasterOption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            previewItem: '',
            onPage: 'Preview',
            arr_temp_edit: [],
            arr_save: [],
            status: '',
            type: '',
            code: '',
            description: '',
            checkAll: true,
            checked: ''
        }
    }

    setUniqueArray = async (arroption) => new Promise((resolve, reject) => {
        let newArray = [];
        let uniqueObject = {};

        for (let i in arroption) {
            let objTitle = arroption[i]['value'];
            uniqueObject[objTitle] = arroption[i];
        }

        for (let i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }
        resolve(newArray)
    })

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/flim/MasterOption');

        if (localStorage.getItem("ID_User") !== null) {
            this.preChooseOption()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    preChooseOption = () => {

        let status = ''
        console.log('type', localStorage.getItem("type"))

        if (localStorage.getItem("type") !== null) {
            status = localStorage.getItem("type")
        }
        this.setState({ isLoading: false, status: status }, () => {
            this.chooseOption(status)
        })
    }

    chooseOption = (value) => {
        this.setState({ status: value, show_item: '', arr_save: [], checkAll: true, checked: '' }, () => {
            localStorage.setItem("type", this.state.status)
        })
        if (value === 'ItemG1') {
            this.getOptionMaster_ItemG1();
        } else if (value === 'ItemG2') {
            this.getoption_ItemG2();
        } else if (value === 'ItemG3') {
            this.getoption_ItemG3();
        } else if (value === 'IBrand1') {
            this.getoption_Ibrand1();
        } else if (value === 'IBrand2') {
            this.getoption_Ibrand2();
        } else if (value === 'Rawmat') {
            this.getoption_Rawmat();
        } else if (value === 'SortProduct') {
            this.getoption_SortProduct();
        } else if (value === 'Size') {
            this.getoption_Size();
        } else if (value === 'Detail') {
            this.getoption_Detail();
        }
    }

    getOptionMaster_ItemG1 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_type = []
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            type: '',
            code: '',
            description: ''
        }
        let url = proxy.server + '/flim/getMaster_ItemG1'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_type.push(
                        { value: val.type, label: val.type }
                    )
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)
                let newArray_type = await this.setUniqueArray(arroption_type)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({ option_type: newArray_type, option_code: newArray_code, option_description: newArray_description }, () => {
                    this.getMaster_ItemG1()
                })
            })
    }

    getMaster_ItemG1 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })

        const { type, code, description } = this.state
        let arr = []
        let dataWhere = {
            type: type,
            code: code,
            description: description
        }
        let url = proxy.server + '/flim/getMaster_ItemG1'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.type}</td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    keys: ['type', 'code', 'description'],
                    filename: 'MasterItemG1' + moment().format('YYYYMMDD'),
                    workbookExport: <Workbook.Sheet data={responseJson.result} name="sheet1">
                        <Workbook.Column label="type" value="type" />
                        <Workbook.Column label="code" value="code" />
                        <Workbook.Column label="description" value="description" />
                    </Workbook.Sheet>,
                    workbookTempplate: <Workbook filename={'templateMasterItemG1.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                        <Workbook.Sheet data={[{
                            type: '',
                            code: '',
                            description: '',
                        }]} name="sheet1">
                            <Workbook.Column label="type" value="type" />
                            <Workbook.Column label="code" value="code" />
                            <Workbook.Column label="description" value="description" />
                        </Workbook.Sheet>
                    </Workbook>
                })
            })
    }

    getoption_ItemG2 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            code: '',
            description: ''
        }
        let url = proxy.server + '/flim/getMaster_ItemG2'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({ option_code: newArray_code, option_description: newArray_description }, () => {
                    this.getMaster_ItemG2()
                })
            })
    }

    getMaster_ItemG2 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        const { code, description } = this.state
        let arr = []
        let dataWhere = {
            code: code,
            description: description
        }
        let url = proxy.server + '/flim/getMaster_ItemG2'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    keys: ['code', 'description'],
                    filename: 'MasterIbrand1' + moment().format('YYYYMMDD'),
                    workbookExport: <Workbook.Sheet data={responseJson.result} name="sheet1">
                        <Workbook.Column label="code" value="code" />
                        <Workbook.Column label="description" value="description" />
                    </Workbook.Sheet>,
                    workbookTempplate: <Workbook filename={'templateMasterIbrand1.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                        <Workbook.Sheet data={[{
                            code: '',
                            description: '',
                        }]} name="sheet1">
                            <Workbook.Column label="type" value="type" />
                            <Workbook.Column label="code" value="code" />
                            <Workbook.Column label="description" value="description" />
                        </Workbook.Sheet>
                    </Workbook>
                })
            })
    }

    getoption_ItemG3 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_type = []
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            type: '',
            code: '',
            description: ''
        }
        let url = proxy.server + '/flim/getMaster_ItemG3'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_type.push(
                        { value: val.type, label: val.type }
                    )
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)
                let newArray_type = await this.setUniqueArray(arroption_type)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({ option_type: newArray_type, option_code: newArray_code, option_description: newArray_description }, () => {
                    this.getMaster_ItemG3()
                })
            })
    }

    getMaster_ItemG3 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })

        const { type, code, description } = this.state
        let arr = []
        let dataWhere = {
            type: type,
            code: code,
            description: description
        }
        let url = proxy.server + '/flim/getMaster_ItemG3'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.type}</td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    keys: ['type', 'code', 'description'],
                    filename: 'MasterItemG3' + moment().format('YYYYMMDD'),
                    workbookExport: <Workbook.Sheet data={responseJson.result} name="sheet1">
                        <Workbook.Column label="type" value="type" />
                        <Workbook.Column label="code" value="code" />
                        <Workbook.Column label="description" value="description" />
                    </Workbook.Sheet>,
                    workbookTempplate: <Workbook filename={'templateMasterItemG3.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                        <Workbook.Sheet data={[{
                            type: '',
                            code: '',
                            description: '',
                        }]} name="sheet1">
                            <Workbook.Column label="type" value="type" />
                            <Workbook.Column label="code" value="code" />
                            <Workbook.Column label="description" value="description" />
                        </Workbook.Sheet>
                    </Workbook>
                })
            })
    }

    getoption_Ibrand1 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            code: '',
            description: ''
        }
        let url = proxy.server + '/flim/getMaster_Ibrand1'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({ option_code: newArray_code, option_description: newArray_description }, () => {
                    this.getMaster_Ibrand1()
                })
            })
    }

    getMaster_Ibrand1 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        const { code, description } = this.state
        let arr = []
        let dataWhere = {
            code: code,
            description: description
        }
        let url = proxy.server + '/flim/getMaster_Ibrand1'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    keys: ['code', 'description'],
                    filename: 'MasterIbrand1' + moment().format('YYYYMMDD'),
                    workbookExport: <Workbook.Sheet data={responseJson.result} name="sheet1">
                        <Workbook.Column label="code" value="code" />
                        <Workbook.Column label="description" value="description" />
                    </Workbook.Sheet>,
                    workbookTempplate: <Workbook filename={'templateMasterIbrand1.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                        <Workbook.Sheet data={[{
                            code: '',
                            description: '',
                        }]} name="sheet1">
                            <Workbook.Column label="type" value="type" />
                            <Workbook.Column label="code" value="code" />
                            <Workbook.Column label="description" value="description" />
                        </Workbook.Sheet>
                    </Workbook>
                })
            })
    }

    getoption_Ibrand2 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            code: '',
            description: ''
        }
        let url = proxy.server + '/flim/getMaster_Ibrand2'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({ option_code: newArray_code, option_description: newArray_description }, () => {
                    this.getMaster_Ibrand2()
                })
            })
    }

    getMaster_Ibrand2 = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        const { code, description } = this.state
        let arr = []
        let dataWhere = {
            code: code,
            description: description
        }
        let url = proxy.server + '/flim/getMaster_Ibrand2'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    keys: ['code', 'description'],
                    filename: 'MasterIbrand2' + moment().format('YYYYMMDD'),
                    workbookExport: <Workbook.Sheet data={responseJson.result} name="sheet1">
                        <Workbook.Column label="code" value="code" />
                        <Workbook.Column label="description" value="description" />
                    </Workbook.Sheet>,
                    workbookTempplate: <Workbook filename={'templateMasterIbrand2.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                        <Workbook.Sheet data={[{
                            code: '',
                            description: '',
                        }]} name="sheet1">
                            <Workbook.Column label="type" value="type" />
                            <Workbook.Column label="code" value="code" />
                            <Workbook.Column label="description" value="description" />
                        </Workbook.Sheet>
                    </Workbook>
                })
            })
    }

    getoption_Rawmat = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            code: '',
            description: ''
        }
        let url = proxy.server + '/flim/getMaster_Rawmat'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({ option_code: newArray_code, option_description: newArray_description }, () => {
                    this.getMaster_Rawmat()
                })
            })
    }

    getMaster_Rawmat = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        const { code, description } = this.state
        let arr = []
        let dataWhere = {
            code: code,
            description: description
        }
        let url = proxy.server + '/flim/getMaster_Rawmat'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    keys: ['code', 'description'],
                    filename: 'MasterRawmat' + moment().format('YYYYMMDD'),
                    workbookExport: <Workbook.Sheet data={responseJson.result} name="sheet1">
                        <Workbook.Column label="code" value="code" />
                        <Workbook.Column label="description" value="description" />
                    </Workbook.Sheet>,
                    workbookTempplate: <Workbook filename={'templateMasterRawmat.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                        <Workbook.Sheet data={[{
                            code: '',
                            description: '',
                        }]} name="sheet1">
                            <Workbook.Column label="type" value="type" />
                            <Workbook.Column label="code" value="code" />
                            <Workbook.Column label="description" value="description" />
                        </Workbook.Sheet>
                    </Workbook>
                })
            })
    }

    getoption_SortProduct = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            code: '',
            description: ''
        }
        let url = proxy.server + '/flim/getMaster_SortProduct'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({ option_code: newArray_code, option_description: newArray_description }, () => {
                    this.getMaster_SortProduct()
                })
            })
    }

    getMaster_SortProduct = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        const { code, description } = this.state
        let arr = []
        let dataWhere = {
            code: code,
            description: description
        }
        let url = proxy.server + '/flim/getMaster_SortProduct'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    keys: ['code', 'description'],
                    filename: 'MasterSortProduct' + moment().format('YYYYMMDD'),
                    workbookExport: <Workbook.Sheet data={responseJson.result} name="sheet1">
                        <Workbook.Column label="code" value="code" />
                        <Workbook.Column label="description" value="description" />
                    </Workbook.Sheet>,
                    workbookTempplate: <Workbook filename={'templateMasterSortProduct.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                        <Workbook.Sheet data={[{
                            code: '',
                            description: '',
                        }]} name="sheet1">
                            <Workbook.Column label="type" value="type" />
                            <Workbook.Column label="code" value="code" />
                            <Workbook.Column label="description" value="description" />
                        </Workbook.Sheet>
                    </Workbook>
                })
            })
    }

    getoption_Size = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            code: '',
            description: ''
        }
        let url = proxy.server + '/flim/getMaster_Size'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({ option_code: newArray_code, option_description: newArray_description }, () => {
                    this.getMaster_Size()
                })
            })
    }

    getMaster_Size = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        const { code, description } = this.state
        let arr = []
        let dataWhere = {
            code: code,
            description: description
        }
        let url = proxy.server + '/flim/getMaster_Size'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    keys: ['code', 'description'],
                    filename: 'MasterSize' + moment().format('YYYYMMDD'),
                    workbookExport: <Workbook.Sheet data={responseJson.result} name="sheet1">
                        <Workbook.Column label="code" value="code" />
                        <Workbook.Column label="description" value="description" />
                    </Workbook.Sheet>,
                    workbookTempplate: <Workbook filename={'templateMasterSize.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                        <Workbook.Sheet data={[{
                            code: '',
                            description: '',
                        }]} name="sheet1">
                            <Workbook.Column label="type" value="type" />
                            <Workbook.Column label="code" value="code" />
                            <Workbook.Column label="description" value="description" />
                        </Workbook.Sheet>
                    </Workbook>
                })
            })
    }

    getoption_Detail = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_code = []
        let arroption_description = []
        let dataWhere = {
            code: '',
            description: ''
        }
        let url = proxy.server + '/flim/getMaster_Detail'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_code.push(
                        { value: val.code, label: val.code }
                    )
                    arroption_description.push(
                        { value: val.description, label: val.description }
                    )
                }, this)
                let newArray_code = await this.setUniqueArray(arroption_code)
                let newArray_description = await this.setUniqueArray(arroption_description)

                this.setState({ option_code: newArray_code, option_description: newArray_description }, () => {
                    this.getMaster_Detail()
                })
            })
    }

    getMaster_Detail = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        const { code, description } = this.state
        let arr = []
        let dataWhere = {
            code: code,
            description: description
        }
        let url = proxy.server + '/flim/getMaster_Detail'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    keys: ['code', 'description'],
                    filename: 'MasterDetail' + moment().format('YYYYMMDD'),
                    workbookExport: <Workbook.Sheet data={responseJson.result} name="sheet1">
                        <Workbook.Column label="code" value="code" />
                        <Workbook.Column label="description" value="description" />
                    </Workbook.Sheet>,
                    workbookTempplate: <Workbook filename={'templateMasterDetail.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                        <Workbook.Sheet data={[{
                            code: '',
                            description: '',
                        }]} name="sheet1">
                            <Workbook.Column label="type" value="type" />
                            <Workbook.Column label="code" value="code" />
                            <Workbook.Column label="description" value="description" />
                        </Workbook.Sheet>
                    </Workbook>
                })
            })
    }

    getItem_Edit = () => {
        const { status, result } = this.state
        this.setState({ isLoading: true, onPage: 'Edit' })
        let arr = []
        result.map(function (val, i) {
            if (status === 'ItemG1') {
                arr.push(
                    <tr>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                {
                                    this.state.checked === ''
                                        ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                            onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                        : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                }
                            </bs4.Col>
                        </td>
                        <td>{val.type}</td>
                        <td>{val.code}</td>
                        <td>{val.description}</td>
                    </tr>
                )
            } else if (status === 'ItemG2') {
                arr.push(
                    <tr>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                {
                                    this.state.checked === ''
                                        ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                            onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                        : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                }
                            </bs4.Col>
                        </td>
                        <td>{val.code}</td>
                        <td>{val.description}</td>
                    </tr>
                )
            } else if (status === 'ItemG3') {
                arr.push(
                    <tr>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                {
                                    this.state.checked === ''
                                        ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                            onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                        : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                }
                            </bs4.Col>
                        </td>
                        <td>{val.type}</td>
                        <td>{val.code}</td>
                        <td>{val.description}</td>
                    </tr>
                )
            } else if (status === 'IBrand1') {
                arr.push(
                    <tr>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                {
                                    this.state.checked === ''
                                        ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                            onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                        : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                }
                            </bs4.Col>
                        </td>
                        <td>{val.code}</td>
                        <td>{val.description}</td>
                    </tr>
                )
            } else if (status === 'IBrand2') {
                arr.push(
                    <tr>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                {
                                    this.state.checked === ''
                                        ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                            onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                        : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                }
                            </bs4.Col>
                        </td>
                        <td>{val.code}</td>
                        <td>{val.description}</td>
                    </tr>
                )
            } else if (status === 'Rawmat') {
                arr.push(
                    <tr>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                {
                                    this.state.checked === ''
                                        ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                            onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                        : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                }
                            </bs4.Col>
                        </td>
                        <td>{val.code}</td>
                        <td>{val.description}</td>
                    </tr>
                )
            } else if (status === 'SortProduct') {
                arr.push(
                    <tr>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                {
                                    this.state.checked === ''
                                        ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                            onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                        : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                }
                            </bs4.Col>
                        </td>
                        <td>{val.code}</td>
                        <td>{val.description}</td>
                    </tr>
                )
            } else if (status === 'Size') {
                arr.push(
                    <tr>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                {
                                    this.state.checked === ''
                                        ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                            onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                        : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                }
                            </bs4.Col>
                        </td>
                        <td>{val.code}</td>
                        <td>{val.description}</td>
                    </tr>
                )
            } else if (status === 'Detail') {
                arr.push(
                    <tr>
                        <td style={{ justifyContent: 'center' }}>
                            <bs4.Col>
                                {
                                    this.state.checked === ''
                                        ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                            onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                        : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                }
                            </bs4.Col>
                        </td>
                        <td>{val.code}</td>
                        <td>{val.description}</td>
                    </tr>
                )
            }
        }, this)
        this.setState({ previewItem: arr, isLoading: false })
    }

    checkItem = (check, id) => {
        let data = {}
        if (check === true) {
            data = {
                id: id,
            }
            let arr = this.state.arr_temp_edit.concat(data)
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        } else {
            let arr = this.state.arr_temp_edit

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        }
    }

    checkAll = (check) => {
        let arr = []
        let data = ''
        // let data = {}

        if (check) {
            data = 'checked'
            this.state.result.map(function (val, i) {
                arr.push({
                    id: val.id
                })
            })
        }

        this.setState({
            arr_temp_edit: arr,
            checkAll: !this.state.checkAll,
            checked: data
        }, () => {
            console.log('arr_temp_edit', this.state.arr_temp_edit)
            this.getItem_Edit()
        })
    }

    goto_edit = () => {
        this.props.history.push({
            pathname: '/Flim/editMasterOption',
            state: { id_edit: this.state.arr_temp_edit, type: this.state.status }
        })
    }

    Delete_item = (id) => {
        const { status } = this.state
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true })
            let url
            if (status === 'ItemG1') {
                url = proxy.server + '/flim/delete_ItemG1'
            } else if (status === 'ItemG2') {
                url = proxy.server + '/flim/delete_ItemG2'
            } else if (status === 'ItemG3') {
                url = proxy.server + '/flim/delete_ItemG3'
            } else if (status === 'IBrand1') {
                url = proxy.server + '/flim/delete_Ibrand1'
            } else if (status === 'IBrand2') {
                url = proxy.server + '/flim/delete_Ibrand2'
            } else if (status === 'Rawmat') {
                url = proxy.server + '/flim/delete_Rawmat'
            } else if (status === 'SortProduct') {
                url = proxy.server + '/flim/delete_SortProduct'
            } else if (status === 'Size') {
                url = proxy.server + '/flim/delete_Size'
            } else if (status === 'Detail') {
                url = proxy.server + '/flim/delete_Detail'
            }
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.setState({ arr_save: [], show_item: '' }, () => this.chooseOption(this.state.status))
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถลบข้อมูลได้ กรุณาตรวจสอบอีกครั้ง')
                        })
                    }
                })
        }
    }

    addData = () => {
        const { arr_save, status } = this.state
        let arr = []
        let temp
        let data
        // arr_check.map(function (val, i) {
        if (status === 'ItemG1') {
            data = {
                type: '',
                code: '',
                description: '',
            }
        } else if (status === 'ItemG3') {
            data = {
                type: '',
                code: '',
                description: '',
            }
        } else if (status === 'ItemG2') {
            data = {
                code: '',
                description: '',
            }
        } else if (status === 'IBrand1') {
            data = {
                code: '',
                description: '',
            }
        } else if (status === 'IBrand2') {
            data = {
                code: '',
                description: '',
            }
        } else if (status === 'Rawmat') {
            data = {
                code: '',
                description: '',
            }
        } else if (status === 'SortProduct') {
            data = {
                code: '',
                description: '',
            }
        } else if (status === 'Size') {
            data = {
                code: '',
                description: '',
            }
        } else if (status === 'Detail') {
            data = {
                code: '',
                description: '',
            }
        }

        arr.push(data)

        temp = arr_save.concat(arr)

        this.setState({
            arr_save: temp
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.showItem()
        })
    }

    showItem = () => {
        const { arr_save, status } = this.state
        let arr = []
        arr_save.map(function (val, i) {
            if (status === 'ItemG1') {
                arr.push(
                    <tr>
                        <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="type" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                    </tr>
                )
            } else if (status === 'ItemG3') {
                arr.push(
                    <tr>
                        <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="type" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                    </tr>
                )
            } else if (status === 'ItemG2') {
                arr.push(
                    <tr>
                        <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                    </tr>
                )
            } else if (status === 'IBrand1') {
                arr.push(
                    <tr>
                        <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                    </tr>
                )
            } else if (status === 'IBrand2') {
                arr.push(
                    <tr>
                        <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                    </tr>
                )
            } else if (status === 'Rawmat') {
                arr.push(
                    <tr>
                        <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                    </tr>
                )
            } else if (status === 'SortProduct') {
                arr.push(
                    <tr>
                        <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                    </tr>
                )
            } else if (status === 'Size') {
                arr.push(
                    <tr>
                        <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                    </tr>
                )
            } else if (status === 'Detail') {
                arr.push(
                    <tr>
                        <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                        <td>
                            <bs4.Col sm='12'>
                                <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                            </bs4.Col>
                        </td>
                    </tr>
                )
            }
        }, this)

        this.setState({ show_item: arr }, () => {
            console.log('arr_save', this.state.arr_save)
        })
    }

    onDelete = (index) => {
        this.state.arr_save.splice(index, 1)
        this.setState({
            arr_save: this.state.arr_save,
        }, () => {
            this.showItem()
        })
    }

    handleChangeItem = (index, name, value) => {
        if (name === 'type') {
            this.state.arr_save[index].type = value
        } else if (name === 'code') {
            this.state.arr_save[index].code = value
        } else if (name === 'description') {
            this.state.arr_save[index].description = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            this.showItem()
        })
    }

    saveItem = () => {
        const { status, arr_save } = this.state
        // console.log('arr_save',arr_save)
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            let url
            if (status === 'ItemG1') {
                url = proxy.server + '/flim/insert_ItemG1'
            } else if (status === 'ItemG2') {
                url = proxy.server + '/flim/insert_ItemG2'
            } else if (status === 'ItemG3') {
                url = proxy.server + '/flim/insert_ItemG3'
            } else if (status === 'IBrand1') {
                url = proxy.server + '/flim/insert_Ibrand1'
            } else if (status === 'IBrand2') {
                url = proxy.server + '/flim/insert_Ibrand2'
            } else if (status === 'Rawmat') {
                url = proxy.server + '/flim/insert_Rawmat'
            } else if (status === 'SortProduct') {
                url = proxy.server + '/flim/insert_SortProduct'
            } else if (status === 'Size') {
                url = proxy.server + '/flim/insert_Size'
            } else if (status === 'Detail') {
                url = proxy.server + '/flim/insert_Detail'
            }
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify(arr_save)
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        alert('บันทึกสำเร็จ')
                        this.setState({ arr_save: [], show_item: '' }, () => this.chooseOption(this.state.status))
                    } else {
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    showUpload = () => {
        const keys = this.state.keys
        if (this.state.upload_open === true) {
            var Upload = <bs4.FormGroup row style={{ marginLeft: '25px', marginBottom: '25px', marginRight: 40 }}>
                <bs4.Label style={{ color: 'red', marginRight: "20px" }}> **รองรับเฉพาะไฟล์ .csv เท่านั้น</bs4.Label>
                <CsvParse
                    keys={keys}
                    onDataUploaded={(data) => { this.setState({ arr_save: data }) }}
                    onError={this.handleError}
                    render={onChange => <input type="file" onChange={onChange} />
                    }
                />
            </bs4.FormGroup>
        }

        this.setState({ showUpload: Upload, upload_open: !this.state.upload_open })
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 10 }}>
                    <bs4.Label style={{ fontSize: 23, fontWeight: 500, marginRight: 10 }}>ข้อมูล Option ต่างๆ</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input type='select' onChange={(e) => this.chooseOption(e.target.value)}>
                            <option value=''>------</option>
                            <option value='ItemG1'>ItemG1</option>
                            <option value='ItemG2'>ItemG2</option>
                            <option value='ItemG3'>ItemG3</option>
                            <option value='IBrand1'>IBrand1</option>
                            <option value='IBrand2'>IBrand2</option>
                            <option value='Rawmat'>Rawmat</option>
                            <option value='SortProduct'>SortProduct</option>
                            <option value='Size'>Size</option>
                            <option value='Detail'>Detail</option>
                        </bs4.Input>
                    </bs4.Col>
                    {
                        this.state.onPage === 'Preview'
                            ? <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.addData()}>ADD DATA</bs4.Button>
                                <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getItem_Edit()}>EDIT</bs4.Button>
                            </div>
                            : <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.goto_edit()}>GO TO EDIT</bs4.Button>
                                <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.chooseOption(this.state.status)}>CANCEL</bs4.Button>
                            </div>

                    }
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>

                <bs4.FormGroup row style={{ marginLeft: 10 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 10 }}>{this.state.status}</bs4.Label><div style={{ justifyContent: 'flex-end' }}>
                        <Workbook filename={this.state.filename + '.xlsx'} element={<bs4.Button outline color="success" style={{ fontWeight: 500, marginRight: 20 }}>EXPORT EXCEL</bs4.Button>} >
                            {this.state.workbookExport}
                        </Workbook>
                        <bs4.Button color="warning" outline style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.showUpload()}>IMPORT</bs4.Button>
                        {this.state.workbookTempplate}
                    </div>
                </bs4.FormGroup>
                <bs4.FormGroup row style={{ marginLeft: 10 }}>
                    {this.state.showUpload}
                    {
                        this.state.arr_save.length > 0
                            ? <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.saveItem()}>SAVE</bs4.Button>
                                <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ show_item: '', arr_save: [] }, () => this.chooseOption(this.state.status))}>CANCEL</bs4.Button>
                            </div>
                            : ''
                    }
                </bs4.FormGroup>

                {
                    this.state.status === 'ItemG1'
                        ? <div>
                            <bs4.FormGroup row>
                                <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Type</bs4.Label>
                                <bs4.Col sm='3'>
                                    <Select className="col-md-12"
                                        onChange={(e) => this.setState({ type: e.value })}
                                        options={this.state.option_type}
                                        placeholder={'ค้นหา type'}
                                    />
                                </bs4.Col>
                                <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                                <bs4.Col sm='2'>
                                    <Select className="col-md-12"
                                        onChange={(e) => this.setState({ code: e.value })}
                                        options={this.state.option_code}
                                        placeholder={'ค้นหา code'}
                                    />
                                </bs4.Col>
                                <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                                <bs4.Col sm='3'>
                                    <Select className="col-md-12"
                                        onChange={(e) => this.setState({ description: e.value })}
                                        options={this.state.option_description}
                                        placeholder={'ค้นหา description'}
                                    />
                                </bs4.Col>
                                <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.chooseOption(this.state.status)}>SEARCH</bs4.Button>
                                <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ type: '', code: '', description: '' }, () => this.chooseOption(this.state.status))}>ดูข้อมูลทั้งหมด</bs4.Button>
                            </bs4.FormGroup>
                            <bs4.Table bordered hover>
                                <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th style={{ backgroundColor: '#fff' }} width='2%'>
                                            {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                                        </th>
                                        <th>type</th>
                                        <th>code</th>
                                        <th>description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.show_item}
                                    {this.state.previewItem}
                                </tbody>
                            </bs4.Table>
                        </div>
                        : this.state.status === 'ItemG3'
                            ? <div>
                                <bs4.FormGroup row>
                                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Type</bs4.Label>
                                    <bs4.Col sm='3'>
                                        <Select className="col-md-12"
                                            onChange={(e) => this.setState({ type: e.value })}
                                            options={this.state.option_type}
                                            placeholder={'ค้นหา type'}
                                        />
                                    </bs4.Col>
                                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                                    <bs4.Col sm='2'>
                                        <Select className="col-md-12"
                                            onChange={(e) => this.setState({ code: e.value })}
                                            options={this.state.option_code}
                                            placeholder={'ค้นหา code'}
                                        />
                                    </bs4.Col>
                                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                                    <bs4.Col sm='3'>
                                        <Select className="col-md-12"
                                            onChange={(e) => this.setState({ description: e.value })}
                                            options={this.state.option_description}
                                            placeholder={'ค้นหา description'}
                                        />
                                    </bs4.Col>
                                    <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.chooseOption(this.state.status)}>SEARCH</bs4.Button>
                                    <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ type: '', code: '', description: '' }, () => this.chooseOption(this.state.status))}>ดูข้อมูลทั้งหมด</bs4.Button>
                                </bs4.FormGroup>
                                <bs4.Table bordered hover>
                                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                        <tr style={{ textAlign: 'center' }}>
                                            <th style={{ backgroundColor: '#fff' }} width='2%'>
                                                {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                                            </th>
                                            <th>type</th>
                                            <th>code</th>
                                            <th>description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.show_item}
                                        {this.state.previewItem}
                                    </tbody>
                                </bs4.Table>
                            </div>
                            : this.state.status === 'ItemG2'
                                ? <div>
                                    <bs4.FormGroup row>
                                        <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                                        <bs4.Col sm='4'>
                                            <Select className="col-md-12"
                                                onChange={(e) => this.setState({ code: e.value })}
                                                options={this.state.option_code}
                                                placeholder={'ค้นหา code'}
                                            />
                                        </bs4.Col>
                                        <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                                        <bs4.Col sm='4'>
                                            <Select className="col-md-12"
                                                onChange={(e) => this.setState({ description: e.value })}
                                                options={this.state.option_description}
                                                placeholder={'ค้นหา description'}
                                            />
                                        </bs4.Col>
                                        <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.chooseOption(this.state.status)}>SEARCH</bs4.Button>
                                        <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ type: '', code: '', description: '' }, () => this.chooseOption(this.state.status))}>ดูข้อมูลทั้งหมด</bs4.Button>
                                    </bs4.FormGroup>
                                    <bs4.Table bordered hover>
                                        <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                            <tr style={{ textAlign: 'center' }}>
                                                <th style={{ backgroundColor: '#fff' }} width='2%'>
                                                    {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                                                </th>
                                                <th>code</th>
                                                <th>description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.show_item}
                                            {this.state.previewItem}
                                        </tbody>
                                    </bs4.Table>
                                </div>
                                : this.state.status === 'IBrand1'
                                    ? <div>
                                        <bs4.FormGroup row>
                                            <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                                            <bs4.Col sm='4'>
                                                <Select className="col-md-12"
                                                    onChange={(e) => this.setState({ code: e.value })}
                                                    options={this.state.option_code}
                                                    placeholder={'ค้นหา code'}
                                                />
                                            </bs4.Col>
                                            <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                                            <bs4.Col sm='4'>
                                                <Select className="col-md-12"
                                                    onChange={(e) => this.setState({ description: e.value })}
                                                    options={this.state.option_description}
                                                    placeholder={'ค้นหา description'}
                                                />
                                            </bs4.Col>
                                            <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.chooseOption(this.state.status)}>SEARCH</bs4.Button>
                                            <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ type: '', code: '', description: '' }, () => this.chooseOption(this.state.status))}>ดูข้อมูลทั้งหมด</bs4.Button>
                                        </bs4.FormGroup>
                                        <bs4.Table bordered hover>
                                            <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th style={{ backgroundColor: '#fff' }} width='2%'>
                                                        {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                                                    </th>
                                                    <th>code</th>
                                                    <th>description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.show_item}
                                                {this.state.previewItem}
                                            </tbody>
                                        </bs4.Table>
                                    </div>
                                    : this.state.status === 'IBrand2'
                                        ? <div>
                                            <bs4.FormGroup row>
                                                <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                                                <bs4.Col sm='4'>
                                                    <Select className="col-md-12"
                                                        onChange={(e) => this.setState({ code: e.value })}
                                                        options={this.state.option_code}
                                                        placeholder={'ค้นหา code'}
                                                    />
                                                </bs4.Col>
                                                <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                                                <bs4.Col sm='4'>
                                                    <Select className="col-md-12"
                                                        onChange={(e) => this.setState({ description: e.value })}
                                                        options={this.state.option_description}
                                                        placeholder={'ค้นหา description'}
                                                    />
                                                </bs4.Col>
                                                <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.chooseOption(this.state.status)}>SEARCH</bs4.Button>
                                                <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ type: '', code: '', description: '' }, () => this.chooseOption(this.state.status))}>ดูข้อมูลทั้งหมด</bs4.Button>
                                            </bs4.FormGroup>
                                            <bs4.Table bordered hover>
                                                <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                    <tr style={{ textAlign: 'center' }}>
                                                        <th style={{ backgroundColor: '#fff' }} width='2%'>
                                                            {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                                                        </th>
                                                        <th>code</th>
                                                        <th>description</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.show_item}
                                                    {this.state.previewItem}
                                                </tbody>
                                            </bs4.Table>
                                        </div>
                                        : this.state.status === 'Rawmat'
                                            ? <div>
                                                <bs4.FormGroup row>
                                                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                                                    <bs4.Col sm='4'>
                                                        <Select className="col-md-12"
                                                            onChange={(e) => this.setState({ code: e.value })}
                                                            options={this.state.option_code}
                                                            placeholder={'ค้นหา code'}
                                                        />
                                                    </bs4.Col>
                                                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                                                    <bs4.Col sm='4'>
                                                        <Select className="col-md-12"
                                                            onChange={(e) => this.setState({ description: e.value })}
                                                            options={this.state.option_description}
                                                            placeholder={'ค้นหา description'}
                                                        />
                                                    </bs4.Col>
                                                    <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.chooseOption(this.state.status)}>SEARCH</bs4.Button>
                                                    <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ type: '', code: '', description: '' }, () => this.chooseOption(this.state.status))}>ดูข้อมูลทั้งหมด</bs4.Button>
                                                </bs4.FormGroup>
                                                <bs4.Table bordered hover>
                                                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                        <tr style={{ textAlign: 'center' }}>
                                                            <th style={{ backgroundColor: '#fff' }} width='2%'>
                                                                {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                                                            </th>
                                                            <th>code</th>
                                                            <th>description</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.show_item}
                                                        {this.state.previewItem}
                                                    </tbody>
                                                </bs4.Table>
                                            </div>
                                            : this.state.status === 'SortProduct'
                                                ? <div>
                                                    <bs4.FormGroup row>
                                                        <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                                                        <bs4.Col sm='4'>
                                                            <Select className="col-md-12"
                                                                onChange={(e) => this.setState({ code: e.value })}
                                                                options={this.state.option_code}
                                                                placeholder={'ค้นหา code'}
                                                            />
                                                        </bs4.Col>
                                                        <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                                                        <bs4.Col sm='4'>
                                                            <Select className="col-md-12"
                                                                onChange={(e) => this.setState({ description: e.value })}
                                                                options={this.state.option_description}
                                                                placeholder={'ค้นหา description'}
                                                            />
                                                        </bs4.Col>
                                                        <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.chooseOption(this.state.status)}>SEARCH</bs4.Button>
                                                        <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ type: '', code: '', description: '' }, () => this.chooseOption(this.state.status))}>ดูข้อมูลทั้งหมด</bs4.Button>
                                                    </bs4.FormGroup>
                                                    <bs4.Table bordered hover>
                                                        <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <th style={{ backgroundColor: '#fff' }} width='2%'>
                                                                    {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                                                                </th>
                                                                <th>code</th>
                                                                <th>description</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.show_item}
                                                            {this.state.previewItem}
                                                        </tbody>
                                                    </bs4.Table>
                                                </div>
                                                : this.state.status === 'Size'
                                                    ? <div>
                                                        <bs4.FormGroup row>
                                                            <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                                                            <bs4.Col sm='4'>
                                                                <Select className="col-md-12"
                                                                    onChange={(e) => this.setState({ code: e.value })}
                                                                    options={this.state.option_code}
                                                                    placeholder={'ค้นหา code'}
                                                                />
                                                            </bs4.Col>
                                                            <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                                                            <bs4.Col sm='4'>
                                                                <Select className="col-md-12"
                                                                    onChange={(e) => this.setState({ description: e.value })}
                                                                    options={this.state.option_description}
                                                                    placeholder={'ค้นหา description'}
                                                                />
                                                            </bs4.Col>
                                                            <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.chooseOption(this.state.status)}>SEARCH</bs4.Button>
                                                            <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ type: '', code: '', description: '' }, () => this.chooseOption(this.state.status))}>ดูข้อมูลทั้งหมด</bs4.Button>
                                                        </bs4.FormGroup>
                                                        <bs4.Table bordered hover>
                                                            <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                                <tr style={{ textAlign: 'center' }}>
                                                                    <th style={{ backgroundColor: '#fff' }} width='2%'>
                                                                        {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                                                                    </th>
                                                                    <th>code</th>
                                                                    <th>description</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.show_item}
                                                                {this.state.previewItem}
                                                            </tbody>
                                                        </bs4.Table>
                                                    </div>
                                                    : this.state.status === 'Detail'
                                                        ? <div>
                                                            <bs4.FormGroup row>
                                                                <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>code</bs4.Label>
                                                                <bs4.Col sm='4'>
                                                                    <Select className="col-md-12"
                                                                        onChange={(e) => this.setState({ code: e.value })}
                                                                        options={this.state.option_code}
                                                                        placeholder={'ค้นหา code'}
                                                                    />
                                                                </bs4.Col>
                                                                <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>description</bs4.Label>
                                                                <bs4.Col sm='4'>
                                                                    <Select className="col-md-12"
                                                                        onChange={(e) => this.setState({ description: e.value })}
                                                                        options={this.state.option_description}
                                                                        placeholder={'ค้นหา description'}
                                                                    />
                                                                </bs4.Col>
                                                                <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.chooseOption(this.state.status)}>SEARCH</bs4.Button>
                                                                <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ type: '', code: '', description: '' }, () => this.chooseOption(this.state.status))}>ดูข้อมูลทั้งหมด</bs4.Button>
                                                            </bs4.FormGroup>
                                                            <bs4.Table bordered hover>
                                                                <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                                                                    <tr style={{ textAlign: 'center' }}>
                                                                        <th style={{ backgroundColor: '#fff' }} width='2%'>
                                                                            {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                                                                        </th>
                                                                        <th>code</th>
                                                                        <th>description</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {this.state.show_item}
                                                                    {this.state.previewItem}
                                                                </tbody>
                                                            </bs4.Table>
                                                        </div>
                                                        : <div></div>
                }
            </div>
        </div>
    }
}

export default Film_MasterOption